import * as XLSX from 'xlsx';

// Export Revenue Officers to Excel
export const exportRevenueOfficersToExcel = (officers, filename = 'revenue_officers.xlsx') => {
  try {
    // Prepare data for Excel
    const excelData = officers.map(officer => ({
      'Officer Name': officer.full_name || `${officer.first_name} ${officer.last_name}`,
      'Email': officer.email || '',
      'Phone': officer.phone || '',
      'Zone': officer.zone_name || 'Not Assigned',
      'Status': officer.status || 'Active',
      'MMDA': officer.mmda_name || '',
      'Created Date': officer.created_at ? new Date(officer.created_at).toLocaleDateString() : '',
    }));

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Set column widths
    const columnWidths = [
      { wch: 20 }, // Officer Name
      { wch: 25 }, // Email
      { wch: 15 }, // Phone
      { wch: 20 }, // Zone
      { wch: 10 }, // Status
      { wch: 20 }, // MMDA
      { wch: 15 }, // Created Date
    ];
    worksheet['!cols'] = columnWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Revenue Officers');

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, filename);
    
    return true;
  } catch (error) {
    console.error('Error exporting Revenue Officers to Excel:', error);
    return false;
  }
};

// Export Traders to Excel
export const exportTradersToExcel = (traders, filename = 'traders.xlsx') => {
  try {
    // Prepare data for Excel
    const excelData = traders.map(trader => ({
      'Business Name': trader.business_name || '',
      'Owner Name': trader.owner_name || '',
      'Phone': trader.phone || '',
      'Business Type': trader.business_type || 'General',
      'Zone': trader.zone_name || 'Not Assigned',
      'Location': trader.location || '',
      'Registration Date': trader.registration_date ? new Date(trader.registration_date).toLocaleDateString() : 
                          trader.created_at ? new Date(trader.created_at).toLocaleDateString() : '',
      'Status': trader.status || 'Active',
      'MMDA': trader.mmda_name || '',
    }));

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Set column widths
    const columnWidths = [
      { wch: 25 }, // Business Name
      { wch: 20 }, // Owner Name
      { wch: 15 }, // Phone
      { wch: 15 }, // Business Type
      { wch: 20 }, // Zone
      { wch: 25 }, // Location
      { wch: 15 }, // Registration Date
      { wch: 10 }, // Status
      { wch: 20 }, // MMDA
    ];
    worksheet['!cols'] = columnWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Traders');

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, filename);
    
    return true;
  } catch (error) {
    console.error('Error exporting Traders to Excel:', error);
    return false;
  }
};

// Show success/error messages
export const showExportMessage = (success, type) => {
  if (success) {
    alert(`✅ ${type} exported successfully! Check your Downloads folder.`);
  } else {
    alert(`❌ Error exporting ${type}. Please try again.`);
  }
};
